import React, { useContext, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import NavbarTop from 'components/navbar/top/NavbarTop';
import NavbarVertical from 'components/navbar/vertical/NavbarVertical';
import AppContext from 'context/Context';
import Footer from 'components/footer/Footer';
import ProductProvider from 'components/app/e-commerce/ProductProvider';
import classNames from 'classnames';
//import AuthModal from 'newComponents/AuthModal';//
import AuthContext from 'newComponents/AuthContext';
import { Link } from 'react-router-dom';

const MainLayout = () => {
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes('kanban');
  // const isChat = pathname.includes('chat');

    const authContext = useContext(AuthContext);
    
  const {
    config: { isFluid, navbarPosition }
  } = useContext(AppContext);

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={isFluid ? 'container-fluid' : 'container'} style={{maxWidth:800}}>
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
        <NavbarVertical />
      )}
      {/*<AuthModal/>*/}
      <ProductProvider>
        <div className={classNames('content', { 'pb-0': isKanban })}>
          <NavbarTop />
          {/*------ Main Routes ------*/}
<div style={{"maxWidth":"800px","marginLeft":"auto","marginRight":"auto"}}>

{ (()=>{
    /*if (1+1==3){//authContext["user"] == null){
 console.log("user == null");
        return (
            <p>Loading2...</p>
               )
    }
else{*/
    console.log("user != null");
    return (<>
    <Outlet />
    <div style={{textAlign:"center",marginTop:30,fontSize:"smaller"}}>
  <span><Link to="/">Terms of Service</Link> | <Link to="/">Privacy Policy</Link> | TerritoryDB 2022 ©</span>
  
   </div>
  </>
    )})()
}
      </div>
          {!isKanban && <Footer />}
        </div>
      </ProductProvider>
    </div>
  );
};

export default MainLayout;
